import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {SharedService} from "./sharedService";
import {catchError} from "rxjs/operators";
import {Observable, pipe} from "rxjs";

@Injectable({providedIn: 'root'})
export class DocumentService {

    constructor(private http: HttpClient,
                private sharedService: SharedService) {
    }


    get$(id: string): any {
        return this.http.get<any>(this.sharedService.apiUrl('api/documents', id),
            {responseType: 'blob' as 'json'})
            .pipe(
                catchError(this.sharedService.handleError('getDocument'))
            );
    }

    list$(entity, entityId): any {
        return this.http.get<any>(this.sharedService.apiUrl('api/documents', entity + "/" + entityId))
            .pipe(catchError(this.sharedService.handleError<any>('list')));
    }

    add$(entity, entityId, file): Observable<any> {
        const formData: FormData = new FormData();
        formData.append('file', file);
        return this.http.post<any>(this.sharedService.apiUrl('api/documents', `${entity}/${entityId}`), formData)
            .pipe(catchError(this.sharedService.handleError<any>('addDocument')));
    }

    delete$(id: string): any {
        return this.http.delete<any>(this.sharedService.apiUrl('api/documents', id))
            .pipe(catchError(this.sharedService.handleError<any>('deleteDocument')));
    }

}
